import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type EntityRef } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";

export enum Actions {
  SetActiveTag = "PORFTOLIO_GALLERY_MODULE_SET_ACTIVE_TAG"
}

export type SetActiveTagActionData = EntityRef & {
  tag: string;
};

export const setActiveTag = (props: RootContainerProps, tag: string): ReduxAction<SetActiveTagActionData> => ({
  type: Actions.SetActiveTag,
  data: {
    ...getEntityRef(props),
    tag,
    source: props.source
  }
});
